import { Settings } from 'services/settings'


export default class Routes {
  // ############################################################################
  static widgetCodeUrl() {
    return this.assetUrl('external/widget.js')
  }

  static widgetStyleUrl() {
    return this.assetUrl('external/widget.css')
  }

  // ############################################################################
  static assetUrl(source) {
    return this.assetPath(source, {
      protocol: 'request'
    })
  }

  static assetPath(source, options = {}) {
    source = `/assets/${source}`
    const host = this.computeAssetHost(source, options)
    if (host) {
      return `${host}${source}`
    }
    return source
  }

  static computeAssetHost(source, options) {
    let host
    host = options.host || Settings.asset_host
    if (options.protocol === 'request' && !host) {
      host = window.location.host
    }
    if (!host) {
      return undefined
    }
    switch (options.protocol) {
      case 'relative':
        return `//${host}`
      case 'request':
        return `${window.location.protocol}//${host}`
      default:
        return `${options.protocol}//${host}`
    }
  }
}
